import React, { FC, useState, useEffect } from "react";
import styles from "./styles.module.less";
import { Row, Col, List, message } from "antd";
import classnames from "classnames";
import { LaunchpadLayout } from "../../components/LaunchpadLayout/index";
import { useTitle } from "../../hooks/useTitle";
import { UserPageBasic } from "./Basic";
import { UserPagePassword } from "./Password";
import { UserPageConnection } from "./Connection";
import { UserMfa } from "./Mfa";
import { ImageCrop } from "../../components/ImageCrop";
import { useTranslation } from "react-i18next";

export const UserPage: FC = () => {
  const { t } = useTranslation();

  useTitle(t("common.personalCenter"), "");

  const user = window.__user__;
  const menus = [
    { key: "basic", label: t("user.personalInfo") },
    { key: "password", label: t("user.accPwd") },
    { key: "connection", label: t("login.accBind") },
    { key: "mfa", label: t("user.mfaBind") },
  ];
  const pages: { [key: string]: any } = {
    basic: <UserPageBasic />,
    password: <UserPagePassword />,
    connection: <UserPageConnection />,
    mfa: <UserMfa />,
  };

  const [current, setCurrent] = useState("basic");

  useEffect(() => {
    if (!window.__user__) {
      window.location.href = "/login";
      return;
    }
  }, []);

  return (
    <LaunchpadLayout name="个人中心">
      <Row
        gutter={16}
        style={{
          maxWidth: "1200px",
          margin: "auto",
          padding: "24px 32px",
        }}
      >
        <Col span="6">
          <div className={classnames(styles.card, styles.cardLeft)}>
            <ImageCrop
              defalutImg={user?.photo ?? ""}
              size={66}
              onChange={async (photo) => {
                await window.__authing__.updateProfile({ photo });
                message.success(t("common.updateSuccess"));
              }}
            />
            <h3>{user?.username || "--"}</h3>
          </div>

          <div className={styles.menu}>
            <List>
              {menus.map(({ key, label }) => (
                <List.Item
                  key={key}
                  className={classnames(styles.item, { [styles.active]: current === key })}
                  onClick={() => setCurrent(key)}
                >
                  {label}
                </List.Item>
              ))}
            </List>
          </div>
        </Col>

        <Col span="18">
          <div className={classnames(styles.card, styles.cardRight)}>{pages[current]}</div>
        </Col>
      </Row>
    </LaunchpadLayout>
  );
};
